import { render, staticRenderFns } from "./unificar.vue?vue&type=template&id=0fbb3837"
import script from "./unificar.ts?vue&type=script&lang=js&external"
export * from "./unificar.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbb3837')) {
      api.createRecord('0fbb3837', component.options)
    } else {
      api.reload('0fbb3837', component.options)
    }
    module.hot.accept("./unificar.vue?vue&type=template&id=0fbb3837", function () {
      api.rerender('0fbb3837', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/duplicacoes/prescritoresDuplicados/unificar.vue"
export default component.exports